
import Component from "vue-class-component"
import Produkte from "@/components/custom/Produkte.vue"
import { Vue } from "vue-property-decorator"
import NichtGueltig from "../custom/NichtGueltig.vue"
import ShoppingLogic from "@/logic/bestellung_neu/shopping_logic"
import FilialeHeader from "../custom/FilialeHeader.vue"

@Component({
  name: "ShoppingProdukte",
  components: { Produkte, NichtGueltig, FilialeHeader },
})
export default class ShoppingProdukte extends Vue {
  logic: ShoppingLogic = null

  mounted() {
    this.logic = new ShoppingLogic()
    this.logic.init()
  }
}
